import defaultTheme from './defaultTheme';
const cheapOAirTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0099DD', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0099DD', background: '#0099DD' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0099DD' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0099DD', border: '#0099DD', background: '#0099DD' }), field: {
        focus: '#0099DD',
        label: '#0099DD',
        icon: '#0099DD',
    } });
export default cheapOAirTheme;
